import { useEffect } from "react";
import { CircularProgress, Stack, Typography } from "@mui/material";

type Props = {
  setIsAnalyse: (isAnalyse: boolean) => void;
  progress: number;
  isAnalyzing: boolean;
  isScrapingQueued: boolean;
  isAnalyzeQueued: boolean;
};

export const AnalyseProgress = ({
  setIsAnalyse,
  progress,
  isAnalyzing,
  isScrapingQueued,
  isAnalyzeQueued,
}: Props) => {
  useEffect(() => {
    if (progress === 100) {
      setIsAnalyse(false);
    }
  }, [progress]);

  return (
    <Stack
      direction="row"
      gap="8px"
      alignItems="center"
      justifyContent="center"
    >
      {!isAnalyzing ? (
        <>
          <CircularProgress size={24} sx={{ color: "custom.subTitleModal" }} />
          <Typography variant="button" sx={{ fontWeight: 500 }}>
            {isScrapingQueued
              ? "Queued"
              : isAnalyzeQueued
                ? "Queued"
                : "Searching"}
          </Typography>
        </>
      ) : (
        <>
          <CircularProgress
            size={24}
            sx={{ color: "custom.subTitleModal", flexShrink: 0 }}
          />
          <Typography
            variant="button"
            sx={{ fontWeight: 500, whiteSpace: "nowrap" }}
          >
            Analyzing: {`${progress}%`}
          </Typography>
        </>
      )}
    </Stack>
  );
};
